import getConfig from 'next/config'

import type { Context as CartContext } from '@grandvisionhq/carts-v2'
import type { CheckoutSettings, Consent } from '@grandvisionhq/checkout-v2'
import type { StoreModel } from '@grandvisionhq/store-model'
import { Util as StoreUtils } from '@grandvisionhq/stores'

import {
  isAddressBookEnabled,
  isMultilingualEnabled,
  isMyAccountEnabled,
} from '../util/feature-toggle'

interface SettingsInput {
  cartV2: CartContext.CartContextModel['cart']
  consents: Consent[]
  stores: StoreModel[]
}

const { publicRuntimeConfig } = getConfig()
const { orderTimeOut } = publicRuntimeConfig.checkout

export const getCheckoutConfig = ({
  cartV2,
  consents,
  stores,
}: SettingsInput): CheckoutSettings => {
  let shippingDetails: CheckoutSettings['shippingDetails'] | undefined

  if (cartV2 && (cartV2.billingAddress || cartV2.shippingAddress || cartV2.customerDetails)) {
    shippingDetails = {
      ...(cartV2.billingAddress ? { billingAddress: cartV2.billingAddress } : {}),
      ...(cartV2.shippingAddress ? { deliveryAddress: cartV2.shippingAddress } : {}),
      ...(cartV2.customerDetails ? { customer: cartV2.customerDetails } : {}),
    }
  }

  return {
    account: {
      implicitAccountCreation: false,
      createAccountRequired: false,
    },
    consent: {
      items: consents,
      implicitTermsAndConditions: true,
    },
    shippingDetails: shippingDetails ? shippingDetails : {},
    storeFinder: {
      stores,
      showUseMyLocation: true,
      googleMapsZoom: 6,
      searchWhitelist: ['storeName', 'postalCode', 'streetName', 'town'] as StoreUtils.SearchKey[],
    },
    ...(orderTimeOut ? { orderCreationTimeOutLimit: orderTimeOut } : {}),
    features: {
      isAddressBookEnabled: isAddressBookEnabled(),
      isCompanyEnabled: false,
      isMultilingualEnabled: isMultilingualEnabled(),
      isMyAccountEnabled: isMyAccountEnabled(),
      isPreferredStoreFinderEnabled: true,
    },
  }
}
